import { render, staticRenderFns } from "./GLU.vue?vue&type=template&id=04813ffe&scoped=true"
import script from "./GLU.vue?vue&type=script&lang=js"
export * from "./GLU.vue?vue&type=script&lang=js"
import style0 from "./GLU.vue?vue&type=style&index=0&id=04813ffe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04813ffe",
  null
  
)

export default component.exports